import { type Nullable } from '@Types';
import { type UserAttrs, type RoleName } from 'Users';

export const ROLES_WITH_GRADING_PORTAL_ACCESS: ReadonlyArray<RoleName> = ['admin', 'editor', 'super_editor', 'grader'];

// Roles that have admin-level access to the grading portal (can see All Submissions and Assign Graders tabs)
export const ROLES_WITH_GRADING_PORTAL_ADMIN_ACCESS: ReadonlyArray<RoleName> = ['admin', 'editor', 'super_editor'];

type UserWithRoles = Pick<UserAttrs, 'roles'>;

function getGlobalRole(user: Nullable<UserWithRoles>): RoleName | null {
    if (!user) return null;
    const globalRole = user.roles.find(role => role.resourceId === null && role.name !== 'cannot_create');
    return globalRole?.name ?? null;
}

export function hasGradingPortalAccess(user: Nullable<UserWithRoles>): boolean {
    if (!user) return false;

    const globalRole = getGlobalRole(user);
    if (!globalRole) return false;

    return ROLES_WITH_GRADING_PORTAL_ACCESS.includes(globalRole);
}

/**
 * Checks if the user has admin-level access to the grading portal.
 * Users with admin-level access can see the "All Submissions" and "Assign Graders" tabs.
 * Users with only the "grader" role can only see "My Grading Tasks".
 */
export function hasGradingPortalAdminAccess(user: Nullable<UserWithRoles>): boolean {
    const globalRole = getGlobalRole(user);
    if (!globalRole) return false;

    return ROLES_WITH_GRADING_PORTAL_ADMIN_ACCESS.includes(globalRole);
}
